/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AppointmentMeetingComponent = {
  id?: number
  date?: string
  location?: string
  url?: string
  address?: string
  meetingWith?: string
  type?: AppointmentMeetingComponent.type
}
export namespace AppointmentMeetingComponent {
  export enum type {
    VIDEOCALL = 'videocall',
    PHONE = 'phone',
    LOCATION = 'location',
  }
}
